<template>
  <div>
    <div v-if="OrderLists">
      <ul class="list-head">
        <li :class="item.w" v-for="(item,index) in vocationArr" :key="index">{{item.title}}</li>
      </ul>
      <div class="d-flex align-items-center pt-3 pb-3 border-bottom" v-for="cardItem in list" :key="cardItem.id">
        <p class="w-25">
          <el-popover placement="right" trigger="hover">
            {{cardItem.title}}<span slot="reference">{{cardItem.title | formatString(12)}}</span>
          </el-popover>
        </p>
        <p class="w-20 text-muted" v-if="isAdmin || isGroup">{{cardItem.company || '散客'}}</p>
        <div class="w-20 text-muted">
          <div v-if="isAdmin">{{cardItem.order_type == 6 ? '限时优惠' : '限时抢购'}}</div>
          <div v-else>{{cardItem.type == 1 ? '限时优惠' : '限时抢购'}}</div>
          <div>{{cardItem.date_in | formatTimestamp()}}</div>
        </div>
        <div class="w-30 text-muted">
          <div>{{cardItem.time | formatTimestamp(1)}}</div>
          <div class="breakword">{{cardItem.oid}}</div>
        </div>
        <p class="w-10 text-muted">{{cardItem.num}}</p>
        <p class="w-20">{{cardItem.price}}</p>
        <p class="w-15" :class="$GFUN.FormatColor(cardItem.status)">{{cardItem.status | formatVar('VocationStatusType')}}</p>
        <p class="w-10 text-link cursor-pointer" @click="checkInfo(cardItem)">查看</p>
      </div>
    </div>
    <div v-else>暂无数据</div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'

  export default {
    name: 'VocationOrderItemize',
    data() {
      return {
        list:[],
      }
    },
    computed: {
      ...mapState(['OrderLists']),
      ...mapGetters(['isAdmin','isGroup']),
      vocationArr () {
        let arr = [
          {title: '产品名称', w: 'w-25'},{title: '产品类型/出行时间', w: 'w-20'},
          {title: '购买时间/订单号', w: 'w-30'},{title: '购买数量', w: 'w-10'},
          {title: '订单金额', w: 'w-20'},{title: '状态', w: 'w-15'},{title: '操作', w: 'w-10'},
        ]
        if (this.isAdmin || this.isGroup) arr.splice(1, 0, {title: '门店名称', w: 'w-20'})
        return arr
      }
    },
    watch:{
      OrderLists(val) {
        if (this.isAdmin) {
          if (val instanceof Array)  this.list = val;
          else this.list = val.data;
        } else {
          this.list = val
        }
      }
    },
    methods: {
      checkInfo(cardItem) {
        let changeRoute = this.$router.resolve({name: 'VocationQR', query: {id: cardItem.id,type: this.$route.query.orderType}});
        window.open(changeRoute.href, '_href')
      }
    }
  }
</script>
